__turbopack_context__.v({
  "block": "ProjectRiver-module-scss-module__4nXYKG__block",
  "river": "ProjectRiver-module-scss-module__4nXYKG__river",
  "row": "ProjectRiver-module-scss-module__4nXYKG__row",
  "solo": "ProjectRiver-module-scss-module__4nXYKG__solo",
  "tile": "ProjectRiver-module-scss-module__4nXYKG__tile",
  "video": "ProjectRiver-module-scss-module__4nXYKG__video",
});
